/**
 * Used by plugin build systems to determine if a module is provided by JBrowse
 * globally and thus doesn't need to be bundled. A check in ./modules.tsx makes
 * sure this is in sync with the re-exported modules.
 *
 * Using this instead of just Object.keys(modules) allows this file to be
 * easily used by downstream tooling like simple esbuild scripts, rollup
 * configs, etc. without actually importing all the modules in modules.tsx,
 * which a Object.keys(modules) would do
 */
export default [
  'mobx',
  'mobx-state-tree',
  'react',
  'react/jsx-runtime',
  'react-dom',
  'react-dom/client',
  'mobx-react',
  '@mui/x-data-grid',
  '@mui/material/utils',
  '@material-ui/core/utils',
  'tss-react/mui',
  '@material-ui/core',
  '@mui/material',

  '@mui/material/styles',
  '@material-ui/core/styles',
  '@material-ui/core/Accordion',
  '@material-ui/core/AccordionActions',
  '@material-ui/core/AccordionDetails',
  '@material-ui/core/AccordionSummary',
  '@material-ui/core/Alert',
  '@material-ui/core/AlertTitle',
  '@material-ui/core/Autocomplete',
  '@material-ui/core/Avatar',
  '@material-ui/core/AvatarGroup',
  '@material-ui/core/Backdrop',
  '@material-ui/core/Badge',
  '@material-ui/core/Box',
  '@material-ui/core/Breadcrumbs',
  '@material-ui/core/Button',
  '@material-ui/core/ButtonGroup',
  '@material-ui/core/Card',
  '@material-ui/core/CardActions',
  '@material-ui/core/CardActionArea',
  '@material-ui/core/CardContent',
  '@material-ui/core/CardHeader',
  '@material-ui/core/CardMedia',
  '@material-ui/core/CircularProgress',
  '@material-ui/core/Collapse',
  '@material-ui/core/ClickAwayListener',
  '@material-ui/core/Chip',
  '@material-ui/core/Checkbox',
  '@material-ui/core/Container',
  '@material-ui/core/Dialog',
  '@material-ui/core/DialogActions',
  '@material-ui/core/DialogTitle',
  '@material-ui/core/DialogContent',
  '@material-ui/core/DialogContentText',
  '@material-ui/core/Divider',
  '@material-ui/core/Drawer',
  '@material-ui/core/Fab',
  '@material-ui/core/Fade',
  '@material-ui/core/FilledInput',
  '@material-ui/core/FormLabel',
  '@material-ui/core/FormControl',
  '@material-ui/core/FormControlLabel',
  '@material-ui/core/FormHelperText',
  '@material-ui/core/FormGroup',
  '@material-ui/core/Grid',
  '@material-ui/core/Grid2',
  '@material-ui/core/Grow',
  '@material-ui/core/Icon',
  '@material-ui/core/IconButton',
  '@material-ui/core/Input',
  '@material-ui/core/InputBase',
  '@material-ui/core/InputLabel',
  '@material-ui/core/InputAdornment',
  '@material-ui/core/Link',
  '@material-ui/core/LinearProgress',
  '@material-ui/core/List',
  '@material-ui/core/ListItem',
  '@material-ui/core/ListItemAvatar',
  '@material-ui/core/ListItemSecondaryAction',
  '@material-ui/core/ListItemIcon',
  '@material-ui/core/ListSubheader',
  '@material-ui/core/ListItemText',
  '@material-ui/core/Menu',
  '@material-ui/core/MenuItem',
  '@material-ui/core/MenuList',
  '@material-ui/core/Modal',
  '@material-ui/core/NativeSelect',
  '@material-ui/core/OutlinedInput',
  '@material-ui/core/Pagination',
  '@material-ui/core/PaginationItem',
  '@material-ui/core/Paper',
  '@material-ui/core/Popover',
  '@material-ui/core/Popper',
  '@material-ui/core/Portal',
  '@material-ui/core/Radio',
  '@material-ui/core/RadioGroup',
  '@material-ui/core/Rating',
  '@material-ui/core/ScopedCssBaseline',
  '@material-ui/core/Select',
  '@material-ui/core/Skeleton',
  '@material-ui/core/Slider',
  '@material-ui/core/Snackbar',
  '@material-ui/core/SnackbarContent',
  '@material-ui/core/SpeedDial',
  '@material-ui/core/SpeedDialAction',
  '@material-ui/core/SpeedDialIcon',
  '@material-ui/core/Stack',
  '@material-ui/core/Step',
  '@material-ui/core/StepButton',
  '@material-ui/core/StepConnector',
  '@material-ui/core/StepLabel',
  '@material-ui/core/StepIcon',
  '@material-ui/core/Stepper',
  '@material-ui/core/SvgIcon',
  '@material-ui/core/Switch',
  '@material-ui/core/Tab',
  '@material-ui/core/Table',
  '@material-ui/core/TableBody',
  '@material-ui/core/TableCell',
  '@material-ui/core/TableContainer',
  '@material-ui/core/TableFooter',
  '@material-ui/core/TableHead',
  '@material-ui/core/TablePagination',
  '@material-ui/core/TableRow',
  '@material-ui/core/TableSortLabel',
  '@material-ui/core/Tabs',
  '@material-ui/core/TextField',
  '@material-ui/core/TextareaAutosize',
  '@material-ui/core/ToggleButton',
  '@material-ui/core/ToggleButtonGroup',
  '@material-ui/core/Toolbar',
  '@material-ui/core/Tooltip',
  '@material-ui/core/Typography',

  '@mui/material/Accordion',
  '@mui/material/AccordionActions',
  '@mui/material/AccordionDetails',
  '@mui/material/AccordionSummary',
  '@mui/material/Alert',
  '@mui/material/AlertTitle',
  '@mui/material/Autocomplete',
  '@mui/material/Avatar',
  '@mui/material/AvatarGroup',
  '@mui/material/Backdrop',
  '@mui/material/Badge',
  '@mui/material/Box',
  '@mui/material/Breadcrumbs',
  '@mui/material/Button',
  '@mui/material/ButtonGroup',
  '@mui/material/Card',
  '@mui/material/CardActions',
  '@mui/material/CardActionArea',
  '@mui/material/CardContent',
  '@mui/material/CardHeader',
  '@mui/material/CardMedia',
  '@mui/material/CircularProgress',
  '@mui/material/Collapse',
  '@mui/material/ClickAwayListener',
  '@mui/material/Chip',
  '@mui/material/Checkbox',
  '@mui/material/Container',
  '@mui/material/Dialog',
  '@mui/material/DialogActions',
  '@mui/material/DialogTitle',
  '@mui/material/DialogContent',
  '@mui/material/DialogContentText',
  '@mui/material/Divider',
  '@mui/material/Drawer',
  '@mui/material/Fab',
  '@mui/material/Fade',
  '@mui/material/FilledInput',
  '@mui/material/FormLabel',
  '@mui/material/FormControl',
  '@mui/material/FormControlLabel',
  '@mui/material/FormHelperText',
  '@mui/material/FormGroup',
  '@mui/material/Grid',
  '@mui/material/Grid2',
  '@mui/material/Grow',
  '@mui/material/Icon',
  '@mui/material/IconButton',
  '@mui/material/Input',
  '@mui/material/InputBase',
  '@mui/material/InputLabel',
  '@mui/material/InputAdornment',
  '@mui/material/Link',
  '@mui/material/LinearProgress',
  '@mui/material/List',
  '@mui/material/ListItem',
  '@mui/material/ListItemAvatar',
  '@mui/material/ListItemSecondaryAction',
  '@mui/material/ListItemIcon',
  '@mui/material/ListSubheader',
  '@mui/material/ListItemText',
  '@mui/material/Menu',
  '@mui/material/MenuItem',
  '@mui/material/MenuList',
  '@mui/material/Modal',
  '@mui/material/NativeSelect',
  '@mui/material/OutlinedInput',
  '@mui/material/Pagination',
  '@mui/material/PaginationItem',
  '@mui/material/Paper',
  '@mui/material/Popover',
  '@mui/material/Popper',
  '@mui/material/Portal',
  '@mui/material/Radio',
  '@mui/material/RadioGroup',
  '@mui/material/Rating',
  '@mui/material/ScopedCssBaseline',
  '@mui/material/Select',
  '@mui/material/Skeleton',
  '@mui/material/Slider',
  '@mui/material/Snackbar',
  '@mui/material/SnackbarContent',
  '@mui/material/SpeedDial',
  '@mui/material/SpeedDialAction',
  '@mui/material/SpeedDialIcon',
  '@mui/material/Stack',
  '@mui/material/Step',
  '@mui/material/StepButton',
  '@mui/material/StepConnector',
  '@mui/material/StepLabel',
  '@mui/material/StepIcon',
  '@mui/material/Stepper',
  '@mui/material/SvgIcon',
  '@mui/material/Switch',
  '@mui/material/Tab',
  '@mui/material/Table',
  '@mui/material/TableBody',
  '@mui/material/TableCell',
  '@mui/material/TableContainer',
  '@mui/material/TableFooter',
  '@mui/material/TableHead',
  '@mui/material/TablePagination',
  '@mui/material/TableRow',
  '@mui/material/TableSortLabel',
  '@mui/material/Tabs',
  '@mui/material/TextField',
  '@mui/material/TextareaAutosize',
  '@mui/material/ToggleButton',
  '@mui/material/ToggleButtonGroup',
  '@mui/material/Toolbar',
  '@mui/material/Tooltip',
  '@mui/material/Typography',

  '@material-ui/lab/ToggleButton',
  '@material-ui/lab/ToggleButtonGroup',
  '@material-ui/lab/Autocomplete',
  '@material-ui/lab/Alert',
  '@material-ui/lab',

  '@jbrowse/core/Plugin',
  '@jbrowse/core/pluggableElementTypes',
  '@jbrowse/core/pluggableElementTypes/ViewType',
  '@jbrowse/core/pluggableElementTypes/AdapterType',
  '@jbrowse/core/pluggableElementTypes/DisplayType',
  '@jbrowse/core/pluggableElementTypes/TrackType',
  '@jbrowse/core/pluggableElementTypes/WidgetType',
  '@jbrowse/core/pluggableElementTypes/models',
  '@jbrowse/core/pluggableElementTypes/renderers/ServerSideRendererType',
  '@jbrowse/core/pluggableElementTypes/renderers/CircularChordRendererType',
  '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType',
  '@jbrowse/core/pluggableElementTypes/renderers/FeatureRendererType',
  '@jbrowse/core/pluggableElementTypes/renderers/RendererType',
  '@jbrowse/core/configuration',
  '@jbrowse/core/util/types/mst',
  '@jbrowse/core/ui',
  '@jbrowse/core/ui/theme',
  '@jbrowse/core/util',
  '@jbrowse/core/util/color',
  '@jbrowse/core/util/layouts',
  '@jbrowse/core/util/tracks',
  '@jbrowse/core/util/Base1DViewModel',
  '@jbrowse/core/util/io',
  '@jbrowse/core/util/mst-reflection',
  '@jbrowse/core/util/rxjs',
  '@jbrowse/core/BaseFeatureWidget/BaseFeatureDetail',
  '@jbrowse/core/data_adapters/BaseAdapter',
]
